<template>
  <div class="row">
    <div class="col-md-12">
      <div align="center">
        <div align="center" class="col-md-8 card estilo">
          <div align="center">
            <img class="imagen responsive" :src="listNovedades.foto" />
            <div align="left" class="col-md-11">
              <h1 class="fuente">{{ listNovedades.title | capitalize }}</h1>
            </div>
            <div class="col-md-11" style="margin-bottom: 5px" align="left">
              <time class="time"
                ><i>{{ listNovedades.date | parseDateMinNovedades }}</i></time
              >
            </div>
            <div align="left" class="col-md-11">
              <!--<p align="justify" style="margin-right: 15px">{{listNovedades.article}}</p>-->
              <div
                style="margin-right: 15px"
                v-html="listNovedades.article"
              ></div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Card } from "element-ui";

export default {
  name: "DetalleNovedades",
  components: {
    [Card.name]: Card,
  },
  created() {
    this.$store.dispatch("setNameRoute", "Novedades");
    this.getDetalleNovedades();
    this.leerNovedad();
  },
  data() {
    return {
      // currentDate: new Date(),
      listNovedades: "",
      idNovedad: this.$route.params.id,
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  methods: {
    getDetalleNovedades() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          id: this.$route.params.id,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "novedades/getDetalleNovedades",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listNovedades = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    leerNovedad() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idNovedad: this.idNovedad,
        jwt: this.$store.getters.jwt,
      };
      let vm = this;

      this.axios
        .post(
          this.$store.getters.apiUrl + "novedades/verNovedad",
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$store.dispatch("cargarNotificaciones");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.a {
}

.card {
  padding: 20px;
}

.fuente {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
}

.estilo {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.imagen {
  margin-bottom: 10px;
  border-radius: 5px;
}

.responsive {
  width: 100%;
  height: auto;
}

.time {
  font-size: 16px;
  color: #777;
  line-height: 17px;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1 {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

h1 {
  color: #3d4449;
  font-family: "Roboto Slab", serif;
  font-weight: 700;
  font-size: 3em;
  margin: 0 0 0.5em 0;
  line-height: 1.3;
  color: #1E22AA;
}

h1 a {
  color: inherit;
  text-decoration: none;
  border-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Novedades/DetalleNovedades.vue